export let LANGUAGE_CODE_LATVIAN = 'lv'
export let LANGUAGE_CODE_ENGLISH = 'en'
export let LANGUAGE_CODE_HINDI_INDIA = 'hi'
export let LANGUAGE_CODE_GERMAN = 'de'
export let LANGUAGE_CODE_RUSSIAN = 'ru'
export let LANGUAGE_CODE_POLISH = 'pl'
export let DEFAULT_LANGUAGE = LANGUAGE_CODE_LATVIAN
